import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconContextSearch32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconContextSearch32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M5 9a1 1 0 0 0 1 1h18a1 1 0 1 0 0-2H6a1 1 0 0 0-1 1m0 14a1 1 0 0 0 1 1h7a1 1 0 1 0 0-2H6a1 1 0 0 0-1 1m18-6a3 3 0 1 1-6 0 3 3 0 0 1 6 0m2 0c0 1.02-.305 1.967-.828 2.757l2.535 2.536a1 1 0 0 1-1.414 1.414l-2.536-2.535A5 5 0 1 1 25 17M6 17a1 1 0 1 1 0-2h6a1 1 0 1 1 0 2z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconContextSearch32);
